function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestSuiteActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.89,20.53,2.23,14.75l-1,.67a1,1,0,0,0-.28.27,1,1,0,0,0,.28,1.39l9.66,6.45a2,2,0,0,0,2.22,0l9.66-6.45a1,1,0,0,0,.28-.27,1,1,0,0,0-.28-1.39l-1-.67-8.66,5.78A2,2,0,0,1,10.89,20.53Z",
    style: {
      fill: "#efeff0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.11.47a2,2,0,0,0-2.22,0L1.23,6.92A1,1,0,0,0,1,7.19,1,1,0,0,0,1,8.38a.8.8,0,0,0,.21.2l4.32,2.89a.76.76,0,0,1,.2-.2l2-1.34,9.78-6.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.77,6.92,17.52,3.41,7.74,9.93l-2,1.34a.76.76,0,0,0-.2.2L10.89,15a2,2,0,0,0,2.22,0l9.66-6.45a.8.8,0,0,0,.21-.2l.07-.08A1,1,0,0,0,22.77,6.92Z",
    style: {
      fill: "#efeff0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.77,11.17l-1-.67-.93.63-7.73,5.15a2,2,0,0,1-2.22,0L3.16,11.13l-.93-.63-1,.67a1.07,1.07,0,0,0-.28.28A1,1,0,0,0,1,12.63a1,1,0,0,0,.21.21l1.93,1.29h0l7.73,5.15a2,2,0,0,0,2.22,0l7.73-5.15h0l1.93-1.29a1,1,0,0,0,.21-.21s.05,0,.07-.07A1,1,0,0,0,22.77,11.17Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestSuiteActive);
export default __webpack_public_path__ + "static/media/test-suite-active.7e778feed9631a4c79fbc1e8ba21e1c2.svg";
export { ForwardRef as ReactComponent };